import { getFamilyInfo, UserToken } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { loadFamilyInfoSuccess, ProfilesAction } from "../Profiles";
import {
  setFamilyToken,
  UserAction,
  userLoginError,
  userLoginRequest,
  userLoginSuccess,
} from "./User";

//TODO could be merged with signup
export const onUserRemoteSigninSuccess = (token: UserToken) => {
  return (dispatch: Dispatch<UserAction | ProfilesAction>) => {
    return new Promise((resolve, reject) => {
      dispatch(userLoginRequest());
      setFamilyToken(token.familyToken)(dispatch);
      getFamilyInfo().subscribe({
        next: (res) => {
          dispatch(loadFamilyInfoSuccess(res.profiles, res.subscription));
          dispatch(userLoginSuccess(undefined));
          resolve(token);
        },
        error: (error) => {
          dispatch(userLoginError(error));
          reject(error);
        },
      });
    });
  };
};
